function addScripts(key, callback) {
    const RecatchaEnterprise = window.recaptchaEnterprise || false;

    if(key) {
        let googleReCaptchaUrl = `https://www.google.com/recaptcha/api.js?render=${key}`;

        if (RecatchaEnterprise) {
            googleReCaptchaUrl = `https://www.google.com/recaptcha/enterprise.js?render=${key}`;
        }

        if (!document.querySelectorAll(`[src="${googleReCaptchaUrl}"]`).length) {
            document.body.appendChild(Object.assign(
                document.createElement('script'), {
                    type: 'text/javascript',
                    src: googleReCaptchaUrl,
                    onload: callback
                })
            );
        }
    }
}

function getKey() {
    let recaptchaKey = document.querySelector('[data-spam-key]');
    return recaptchaKey ? recaptchaKey.getAttribute('data-spam-key') : null;
}


export function initialize() {
    let recaptchaKey = getKey();
    let areas = document.querySelectorAll('[data-spam]');

    if(recaptchaKey && areas.length) {
        addScripts(recaptchaKey);
        areas.forEach(function(formElement) {
            formElement.addEventListener('submit', function(event) {
                let ajaxFormActive = formElement.ajaxFormActive || false;
                let recaptchaFormSubmitted = formElement.recaptchaFormSubmitted || false;
                if(ajaxFormActive === false && recaptchaFormSubmitted === false) {
                    event.preventDefault();
                    apply(formElement, function() {
                        formElement.recaptchaFormSubmitted = true;
                        formElement.submit();
                    });
                }
            });
        });
    }
}

export function apply(form, callback) {
    const RecatchaEnterprise = window.recaptchaEnterprise || false;
    let action = form.getAttribute('data-spam');

    if(action) {
        let input = form.querySelector('[name="spamToken"]');

        if(input === null) {
            input = form.querySelector('[name="' + action + 'Value"]');
        }
        console.log(input);

        if(action && input) {
            let recaptchaKey = getKey();

            if (RecatchaEnterprise) {
                grecaptcha.enterprise.ready(function() {
                    grecaptcha.enterprise.execute(recaptchaKey, {action: 'submitForm'}).then(function(token) {
                        input.value = token;
                        callback();
                    });
                });
            } else {
                grecaptcha.ready(function() {
                    grecaptcha.execute(recaptchaKey, {action: action}).then(function(token) {
                        input.value = token;
                        callback();
                    });
                });
            }

            return;
        }
    }

    callback();
}
